__turbopack_context__.v({
  "imageSliderBlock": "rwGd5a_imageSliderBlock",
  "imageSliderBlock__slider": "rwGd5a_imageSliderBlock__slider",
  "imageSliderBlock__wrapper": "rwGd5a_imageSliderBlock__wrapper",
});
